import { encode } from 'string-encode-decode';

export default function encodeCache(id, storage) {
  localStorage.setItem(id, encode(JSON.stringify(storage)));
}
